/* eslint-disable import/order */
import React from 'react';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { notificationLogsEntryPoint } from '@jira/spa-apps__admin-pages-notification-logs/src/notificationLogsEntryPoint.entrypoint.tsx';
import type NotificationLogsType from '@jira/spa-apps__admin-pages-notification-logs/src/NotificationLogs.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { systemConfigurationGeneralResource } from '@jira/router-resources__system-configuration-settings/src/systemConfigurationGeneralResource.tsx';
import { emailNotificationsLogAccessRoute } from '@jira/router-routes__admin-pages-email-notifications-log-routes/src/emailNotificationsLogAccessRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const emailNotificationsLogEntryPointPage = createPageEntryPoint({
	main: notificationLogsEntryPoint,
});

const LazyNotificationLogsType = lazyForPaint<typeof NotificationLogsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-email-notifications-log", jiraSpaEntry: "async-system-email-notifications-log" */ '@jira/spa-apps__admin-pages-notification-logs/src/NotificationLogs.tsx'
		),
	),
);

const NotificationLogs = () => (
	<LazyPage Page={LazyNotificationLogsType} pageId="Notification Logs" shouldShowSpinner={false} />
);

export const emailNotificationsLogAccessRouteEntry: Route = createEntry(
	emailNotificationsLogAccessRoute,
	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: NotificationLogs,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			systemConfigurationGeneralResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyNotificationLogsType],
		pageId: 'admin-settings-email-notifications-log',

		entryPoint() {
			return emailNotificationsLogEntryPointPage;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
